import { styled as materialStyled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

type ICustomToolbarProps = {
  minheight?: number;
};

const CustomToolbar = materialStyled(Toolbar)<ICustomToolbarProps>(({ minheight = 56 }) => ({
  minHeight: `${minheight}px !important`,
  paddingLeft: '16px !important',
  paddingRight: '16px !important',
}));

export default CustomToolbar;
